<template>
<div>
    <div
        v-if="profile.subscription_signature != null"
    >
        <p>
            Your organization, {{profile.subscription_signature.signed_by_organization_name}}, has signed the RedChirp subscription agreement.  
            It was signed by {{profile.subscription_signature.signed_by_first_name}} {{profile.subscription_signature.signed_by_last_name}} at {{$rc.pretty(profile.subscription_signature.signed_time,'time')}} on {{$rc.pretty(profile.subscription_signature.signed_time,'date')}}.
        </p>

        <p>You can download the agreement(s) from the following link(s):</p>

        <m-signature-packet-documents
            :meta_data="profile.subscription_signature.packet_meta_data_documents"
        />
    </div>

    <div
        v-else
    >
        <v-row>
            <v-col>
                <v-text-field
                    label="First Name"
                    v-model="first_name"
                    autocomplete="off"
                />
            </v-col>
            <v-col>
                <v-text-field
                    label="Last Name"
                    v-model="last_name"
                    autocomplete="off"
                />
            </v-col>
        </v-row>

        <v-text-field
            label="Organization Name"
            v-model="organization_name"
            hint="Use your organizations full legal name, for example RedChirp LLC is preferrable to RedChirp"
            autocomplete="off"
        />

        <m-sign-packet
            agreement_type="accept-redchirp-subscription-agreement"
            :organization_id="organization_id"
            :organization_label="organization_name"
            :meta_data="profile.subscription_signature_packet_meta_data"
            v-model="accept_agreement"
            ref="sign-packet"
        />

        <v-alert
            type="error"
            v-if="alert_text != null"
            color="primary"
        >
            {{alert_text}}
        </v-alert>

        <div
            style="text-align: right"
        >
            <v-btn
                color="primary"
                v-on:click="onClickSign"
                :disabled="!allow_sign"
            >
                Sign the Agreement
            </v-btn>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        profile: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            first_name: null,
            last_name: null,
            organization_name: null,
            alert_text: null,
            accept_agreement: false,
            organization_id: null,
        }
    },

    mounted () {
        this.first_name = this.$rc.getDeep(this.profile,'employee_label/employee_first_name');
        this.last_name = this.$rc.getDeep(this.profile,'employee_label/employee_last_name');
        this.organization_name = this.$rc.getDeep(this.profile,'organization_account/label');
        this.organization_id = this.$rc.getDeep(this.profile,'organization_account/organization_id');
    },

    methods: {
        onClickSign() {

            let first_name = this.clean(this.first_name);

            if ( first_name == null )
            {
                this.alert_text = 'Your first name is requried.';
                return;
            }

            let last_name = this.clean(this.last_name);

            if ( last_name == null )
            {
                this.alert_text = 'Your last name is requried.';
                return;
            }

            let organization_name = this.clean(this.organization_name);

            if ( organization_name == null )
            {
                this.alert_text = 'Your organization name is requried.';
                return;
            }

            if ( this.accept_agreement != true )
            {
                this.alert_text = 'You must check the box indicating that you have read and accept the agreement.';
                return;
            }

            this.alert_text = null;
            
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/signatures/sign-agreement',
            
                'params' : {
                        'packet_id': this.profile.subscription_signature_packet.packet_id,
                        'agreement_specimen': '[X] '+this.$refs['sign-packet'].getSpecimen(),
                        'signed_by_employee_id': this.profile.employee_account.employee_id,
                        'signed_by_organization_id': this.profile.employee_account.organization_id,
                        'signed_by_first_name': first_name,
                        'signed_by_last_name': last_name,
                        'signed_by_organization_name': organization_name
                    },
            
                'on_success': (data) => {
                        this.$emit('reload-profile');

                        this.sendProgressAlert();
                    },
            
                'on_error': 'Unable to sign subscription agreement',
            });
        },

        clean(value)
        {
            if ( value == null ) return null;
            value = value.trim();
            if ( value.length == 0 ) return null;

            return value;
        },

        sendProgressAlert()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/send-progress-alert',
            
                'params' : {
                        'organization_id': this.profile.employee_account.organization_id,
                        'alert_pattern': '{organization-label} has signed the RedChirp software subscription agreement'
                    },
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': () => {},
            });
        },
    },

    computed: {
        
        allow_sign()
        {
            if ( !this.$rc.$state.isAuthActorSystemAdmin() )
                return true;

            if ( this.profile.organization_account.organization_id == '9406d3f2-a710-4ca2-a1f1-d0103d4e3406' )
            {
                // Alow this in Red Mountain Outdoors (for testing)
                return true;
            } 

            return false;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>